var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyCod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5V13C4.75 13.5304 4.94754 14.0391 5.29918 14.4142C5.65081 14.7893 6.12772 15 6.625 15H12.25M4.75 5V3C4.75 2.46957 4.94754 1.96086 5.29918 1.58579C5.65081 1.21071 6.12772 1 6.625 1H10.9244C11.173 1.00006 11.4114 1.10545 11.5872 1.293L15.7253 5.707C15.9011 5.89449 15.9999 6.1488 16 6.414V13C16 13.5304 15.8025 14.0391 15.4508 14.4142C15.0992 14.7893 14.6223 15 14.125 15H12.25M4.75 5H2.875C2.37772 5 1.90081 5.21071 1.54917 5.58579C1.19754 5.96086 1 6.46957 1 7V17C1 17.5304 1.19754 18.0391 1.54917 18.4142C1.90081 18.7893 2.37772 19 2.875 19H10.375C10.8723 19 11.3492 18.7893 11.7008 18.4142C12.0525 18.0391 12.25 17.5304 12.25 17V15",
    stroke: "#06311F",
    strokeOpacity: 0.32,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCod);
export default __webpack_public_path__ + "static/media/copy-cod.fd606125.svg";
export { ForwardRef as ReactComponent };